export enum BasemapId {
  topo = 'topo',
  streets = 'streets',
  satellite = 'satellite',
  hybrid = 'hybrid',
  darkGray = 'dark-gray',
  gray = 'gray',
  nationalGeographic = 'national-geographic',
  oceans = 'oceans',
  osm = 'osm',
  terrain = 'terrain',
  darkGrayVector = 'dark-gray-vector',
  grayVector = 'gray-vector',
  streetsVector = 'streets-vector',
  streetsNightVector = 'streets-night-vector',
  streetsNavigationVector = 'streets-navigation-vector',
  topoVector = 'topo-vector',
  streetsReliefVector = 'streets-relief-vector',
}
